// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__vgG8O","inputDescription":"styles_inputDescription__6U1kr"};